import { Button } from "@dash/form";
import { Card, Header4 } from "@dash/page";
import React from "react";
import { MdCompareArrows, MdSync } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

export const ItemSyncOptionsBar: React.FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <div css={{ display: "flex", gap: "1rem", flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
      <OptionCard label="Google Sheets">
        <Button
          variant="outline"
          icon={<MdCompareArrows />}
          onClick={() =>
            navigate(getMegaraxPath.uri("megarax://catalog/diff-sync/{channel}", { channel: "sheetsItem" }))
          }
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Produkty
        </Button>
      </OptionCard>
      <OptionCard label="Business Central">
        <Button
          variant="outline"
          icon={<MdCompareArrows />}
          onClick={() => navigate(getMegaraxPath.uri("megarax://catalog/diff-sync/{channel}", { channel: "bcItem" }))}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Zapasy
        </Button>
      </OptionCard>
      <OptionCard label="Shopify">
        <Button
          variant="outline"
          icon={<MdCompareArrows />}
          onClick={() =>
            navigate(getMegaraxPath.uri("megarax://catalog/diff-sync/{channel}", { channel: "shopifyProduct" }))
          }
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Produkty
        </Button>
        <Button
          variant="outline"
          icon={<MdCompareArrows />}
          onClick={() =>
            navigate(getMegaraxPath.uri("megarax://catalog/diff-sync/{channel}", { channel: "shopifyVariant" }))
          }
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Warianty
        </Button>
        <Button
          variant="outline"
          icon={<MdCompareArrows />}
          onClick={() =>
            navigate(getMegaraxPath.uri("megarax://catalog/diff-sync/{channel}", { channel: "shopifyPrice" }))
          }
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Ceny
        </Button>
      </OptionCard>
    </div>
  );
};

const OptionCard = (props: { label: string; children?: React.ReactNode }) => {
  return (
    <Card
      variant="secondary"
      css={{ flexDirection: "column", justifyContent: "space-between", flexGrow: 0, gap: "1rem" }}
    >
      <Header4>{props.label}</Header4>
      <div css={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>{props.children}</div>
    </Card>
  );
};
